import React from 'react';
import { TabbedShowLayout, Tab, TextField, EmailField, UrlField } from 'react-admin';

import Show from '../common/views/Show';
import CountryField from '../common/fields/CountryField';


const CompanyShow = props => (
	<Show {...props}>
		<TabbedShowLayout>
			<Tab label="Summary">
				<TextField source="name" />
				<CountryField source="country" />
				<TextField source="street" />
				<TextField source="zipcode" />
				<TextField source="city" />
				<TextField source="vat_number" />
				<TextField source="bank_name" />
				<TextField source="bank_bic" />
				<TextField source="bank_iban" />
				<EmailField source="email" />
				<UrlField source="website" />
				<TextField source="phone" />
			</Tab>
		</TabbedShowLayout>
	</Show>
);

export default CompanyShow;